module.exports = __webpack_public_path__ + "img/business-icon-03.98060199.png";